// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input-item[data-v-ee3bad76] {\n  margin-bottom: 20px;\n}\n\n\n/* Target the component wrapper */\n.full-width[data-v-ee3bad76] {\n  width: 100% !important;\n}\n\n/* Ensure the internal input container also takes full width */\n.full-width[data-v-ee3bad76] :deep(.el-input) {\n  width: 100%;\n}\n\n/* Optional: Align text to the left if preferred when wide */\n.full-width[data-v-ee3bad76] :deep(.el-input__inner) {\n  text-align: left;\n  padding-left: 15px;\n}\n\n", ""]);
// Exports
module.exports = exports;
